import React from 'react';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import { Quote } from 'lucide-react';
import './HomePage.css';
import './Waves.css';
import './TestimonialsPage.css'; // New companion styles to make cards pop

function TestimonialsPage() {
    return (
        <div className="homepage-wrapper">
            <Navbar />

            <section id="testimonials" className="section-hero testimonials-view" style={{ background: '#dbf0ff' }}>

                {/* Abstract Background Vector Layers */}
                <div className="svg-bg-wrapper">
                    <svg className="abstract-shape shape-top-right" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0,0 C150,50 350,200 400,400 L400,0 Z" fill="#dfc6f7" opacity="0.4" />
                    </svg>
                    <svg className="abstract-shape shape-bottom-left" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="100" fill="#d1b3f2" opacity="0.3" />
                    </svg>
                </div>

                <div className="testimonials-content-container">
                    <header className="testimonials-header">
                        {/* <span className="subtitle">Client Success Stories</span> */}
                        <h1>Testimonials</h1>
                        <p className="testimonials-lead-in">
                            Discover how personalized instruction helped individuals achieve clear, confident expression.
                        </p>
                    </header>

                    {/* Testimonial Cards Layout Grid */}
                    <div className="testimonials-grid">
















                        {/* Testimonial 2: Stanislava */}
                        <div className="testimonial-card">
                            <div className="quote-icon-badge">
                                <Quote size={20} fill="#6d28d9" stroke="none" />
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    I worked with Alisa for a few months on accent correction and would highly recommend her services! The sessions were targeted depending on what I wanted to work on and at the same time we were able to go through all of the weak spots that I had and practice over and over.
                                </p>
                                <p>
                                    I am now more confident when I speak and also bring into my daily operation something that we worked on with Alisa: to slow down and think before I say the word - almost like drawing a mental picture of how I want that word to sound. Thank you, Alisa!
                                </p>
                                {/* <p>
                                    I worked with Alisa for a few months on accent correction and would highly recommend her services! The sessions were targeted depending on what I wanted to work on and at the same time we were able to go through all of the weak spots that I had and practice over and over.
                                </p>
                                <p>
                                    I am now more confident when I speak and also bring into my daily operation something that we worked on with Alisa: to slow down and think before I say the word - almost like drawing a mental picture of how I want that word to sound. Thank you, Alisa!
                                </p> */}
                            </div>
                            <div className="testimonial-author">
                                <span className="author-name">Stanislava G.</span>
                                <span className="author-meta">Accent Modification Client</span>
                            </div>
                        </div>









                        {/* Testimonial 2: Yuliya */}
                        <div className="testimonial-card">
                            <div className="quote-icon-badge">
                                <Quote size={20} fill="#6d28d9" stroke="none" />
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    I've only been working with Alisa for several weeks, but I've already learned so much. She is clearly highly knowledgeable in her field, and I really appreciate how she tailors her approach to my specific needs.
                                </p>
                                <p>
                                    I'm now much more aware of my speech patterns and better able to notice the nuances of different sounds. Alisa is intelligent, precise, and also just a lovely person to work with. I would gladly recommend her to anyone looking to refine their pronunciation!
                                </p>

                            </div>
                            <div className="testimonial-author">
                                <span className="author-name">Yuliya L.</span>
                                <span className="author-meta">Accent Modification Client</span>
                            </div>
                        </div>





















                        {/* Testimonial 1: Aleksandra */}
                        <div className="testimonial-card">
                            <div className="quote-icon-badge">
                                <Quote size={20} fill="#6d28d9" stroke="none" />
                            </div>
                            <div className="testimonial-body">
                                <p>
                                    I recently completed an accent reduction course with Alisa as my teacher and am thrilled with the results! She created a customized plan specifically for me, focusing on the areas where I had the most difficulty. Her understanding of my particular struggles as a Russian speaker was incredibly helpful. She provided a wealth of advice on how to correct these issues and was persistent in ensuring I fully understood each concept.
                                </p>
                                <p>
                                    Her patience and ability to explain things clearly made each session highly effective. I appreciated how professional and helpful she was throughout the entire process. She listened to my concerns and tailored the lessons to fit my needs perfectly. Every session was well-organized and aimed at making tangible improvements in my accent. Rather than giving general tips, she offered specific feedback that truly made a difference.
                                </p>
                                <p>
                                    Thanks to her dedicated approach, I now feel much more confident when I speak. Friends and colleagues have noticed the improvement and have commented on the clarity of my speech. I highly recommend Alisa to anyone looking to enhance their pronunciation. Her commitment and personalized methodology really set her apart. It was an excellent experience overall, and I am very grateful for her assistance!
                                </p>
                                {/* <p>
                                    I recently completed an accent reduction course with Alisa as my teacher and am thrilled with the results! She created a customized plan specifically for me, focusing on the areas where I had the most difficulty. Her understanding of my particular struggles as a Russian speaker was incredibly helpful.
                                </p>
                                <p>
                                    Her patience and ability to explain things clearly made each session highly effective. Rather than giving general tips, she offered specific feedback that truly made a difference. Thanks to her dedicated approach, I now feel much more confident when I speak. Friends and colleagues have noticed the improvement and have commented on the clarity of my speech.
                                </p> */}
                            </div>
                            <div className="testimonial-author">
                                <span className="author-name">Aleksandra A.</span>
                                <span className="author-meta">Accent Modification Client</span>
                            </div>
                        </div>







                    </div>
                </div>

                {/* Section bottom decorative fluid bridge — Filling into footer color directly */}
                <div className="wave-container">
                    <svg viewBox="0 0 1200 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C26.9,3,57.05,11.58,87.6,18.57,152,33.22,217.15,64.29,321.39,56.44Z"
                            fill="#2e1065" /* Links perfectly with deep purple main-footer */
                        />
                    </svg>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default TestimonialsPage;